export default __webpack_public_path__ + "becfcb594165f4818a0cdb13d780da9d.png";